import { InjectionToken, Provider } from "@angular/core";
import { WINDOW_TOKEN } from "../browser";
import { StorageService, WebStorage } from "./storage.service";

export const LocalStorageService = new InjectionToken<WebStorage>("LocalStorageService");
export const SessionStorageService = new InjectionToken<WebStorage>("SessionStorageService");

export function provideLocalStorage(options: { keyPrefix: string }): Provider[] {
    return [
        {
            provide: LocalStorageService,
            useFactory: () => new StorageService(options.keyPrefix, window.localStorage),
            deps: [WINDOW_TOKEN]
        }
    ];
}

export function provideSessionStorage(options: { keyPrefix: string }): Provider[] {
    return [
        {
            provide: SessionStorageService,
            useFactory: () => new StorageService(options.keyPrefix, window.sessionStorage),
            deps: [WINDOW_TOKEN]
        }
    ];
}
